const config = require('./config.json');

global.config = config;

export default config;
